// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"510a0bc9","951":"2b7353cc"}[chunkId] + ".chunk.js";
};